export default __webpack_public_path__ + "static/media/close.61ad4dbf.svg";